import { IListItem } from "./list-item";

export interface PreselectDeclineReason extends IListItem {
    allowOtherText: boolean
}